<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" :title="title" width="500" >
      <el-form  :model="formInline" class="demo-form-inline">
        <el-form-item label="下单平台">
          <el-input style="width:200px" v-model="formInline.platformCNName" placeholder="请输入下单平台名称" clearable />
        </el-form-item>
        <el-form-item label="下单平台(US)">
          <el-input style="width:200px"  v-model="formInline.platformUSName" placeholder="请输入下单平台英文名称" clearable />
        </el-form-item>
        <el-form-item label="默认延保年限">
          <el-input style="width:200px" type="number" v-model="formInline.platformDefaultYear" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="排序">
          <el-input style="width:200px" type="number" v-model="formInline.order" placeholder="请输入排序，数值越大排名越前" clearable />
        </el-form-item>
        <el-form-item label="平台状态">
          <el-select
              style="width:200px"
              v-model="formInline.status"
              clearable
              placeholder="请选择平台状态"
          >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item >
          <el-button style="margin: 0 auto" type="primary" @click="onSubmit">{{botton}}</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>
<script >
import {ElDialog, ElForm, ElFormItem, ElButton, ElInput, ElSelect, ElOption, ElMessage} from "element-plus";
import {addPlatform,updatePlatform} from "@/utils/api";
export default {
  name: "addPlatform",
  components:{
    ElDialog,ElForm,ElFormItem,ElButton,ElInput,ElSelect,ElOption
  },
  data(){
    return{
      dialogTableVisible:false,
      title:"新建平台",
      botton:"创建平台",
      formInline:{
        order:10,
        status:true
      },
      options:[
        {
          value:true,
          label: '正常',
        },
        {
          value: false,
          label: '禁用',
        },
      ]
    }
  },
  methods:{
    open(data){
      console.log(data)
      this.dialogTableVisible = true
      if(data && data.id){
        this.title = "编辑平台"
        this.botton = "确认编辑"
        this.formInline = data
      }else{
        this.title = "新建平台"
        this.botton = "创建平台"
        this.formInline = {
          order:10,
          platformDefaultYear:null,
          status:true
        }
      }
    },
    onSubmit(){
      if(!this.formInline.platformCNName){
        ElMessage.warning('请填写平台中文昵称')
        return false
      }
      if(!this.formInline.platformUSName){
        ElMessage.warning('请填写平台英文昵称')
        return false
      }
      if(this.formInline.order===null){
        ElMessage.warning('请填写排序')
        return false
      }
      if(this.formInline.status===null){
        ElMessage.warning('请选择平台状态')
        return false
      }
      if(this.title==="新建平台"){
        addPlatform(this.formInline).then((res)=>{
          console.log(res)
          this.dialogTableVisible = false
          this.$emit('close')
        }).catch(err=>{
          console.log(err)
        })
      }else{
        updatePlatform(this.formInline).then((res)=>{
          console.log(res)
          this.dialogTableVisible = false
          this.$emit('close')
        }).catch(err=>{
          console.log(err)
        })
      }

    }
  }
}
</script>
<style scoped>
::v-deep .el-form-item__label{
  width: 100px;
}
</style>